import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

interface UnreviewedToggleProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const UnreviewedToggle = ({ id, checked, onChange }: UnreviewedToggleProps) => (
  <div className="flex items-center gap-2">
    <Checkbox id={id} checked={checked} onCheckedChange={value => onChange(value === true)} />
    <Label htmlFor={id} className="text-sm font-normal cursor-pointer">
      Unreviewed only
    </Label>
  </div>
);

export default UnreviewedToggle;
